import _map from 'lodash/map'
import _get from 'lodash/get'
import _set from 'lodash/set'
import _filter from 'lodash/filter'
import { validateTicketTypeName } from '../../guesttickets/ImportGuestsForm'

export const validateTicket = data => {
  const isTableMap = data.seatMapType === 'table' && data.isSeatMap
  const errors = {}

  if (data.isSeatsIo && data.selectedTab === 'ticketsOnMap') {
    const required = ['email', 'confirmEmail']
    required.forEach(f => {
      if (!_get(data, f)) {
        _set(errors, f, 'Required')
      }
    })
    const email = _get(data, 'email')
    const confirmEmail = _get(data, 'confirmEmail')
    if (email !== confirmEmail)
      _set(errors, 'confirmEmail', 'Please confirm the email address for this ticket')
    const seat_io_tickets = _get(data, 'seat_io_tickets')
    if (seat_io_tickets.length === 0) {
      errors.tickets = 'Required'
    }
    _map(seat_io_tickets, (ticket, index) => {
      if (!ticket.first_name.trim()) {
        _set(errors, 'seat_io_tickets[' + index + '].first_name', 'Required')
      }
      if (!ticket.last_name.trim()) _set(errors, 'seat_io_tickets[' + index + '].last_name', 'Required')
      const addons = _get(ticket, 'add_ons')
      _map(addons, (addon, aindex) => {
        if (!addon.id) _set(errors, 'seat_io_tickets[' + index + '].add_ons[' + aindex + '].id', 'Required')
        if (!addon.quantity)
          _set(errors, 'seat_io_tickets[' + index + '].add_ons[' + aindex + '].quantity', 'Required')
        else if (addon.quantity < 1)
          _set(
            errors,
            'seat_io_tickets[' + index + '].add_ons[' + aindex + '].quantity',
            'Quantity must be greater than 0',
          )
      })
    })
    return errors
  }

  let required = ['email', 'confirmEmail']

  if (!data.ticketTypeID && !data.tableTypeID) {
    if (isTableMap) {
      required.push('tableTypeID')
    } else {
      required.push('ticketTypeID')
    }
  }

  if (!!data.selectedGroup) {
    required.push('selectedDay')
    required.push('selectedTime')
  } else {
    required = _filter(required, r => r !== 'selectedDay' && r !== 'selectedTime')
  }
  required.forEach(f => {
    if (!_get(data, f)) {
      _set(errors, f, 'Required')
    }
  })

  const quantity = _get(data, 'quantity')
  if (quantity < 1) {
    _set(errors, 'quantity', 'Quantity must be greater than 0')
  }

  const email = _get(data, 'email')
  const confirmEmail = _get(data, 'confirmEmail')
  if (email !== confirmEmail) _set(errors, 'confirmEmail', 'Please confirm the email address for this ticket')

  const ticketHolders = _get(data, 'ticketHolders')
  _map(ticketHolders, (holder, index) => {
    if (!holder.first_name.trim()) {
      _set(errors, 'ticketHolders[' + index + '].first_name', 'Required')
    }
    if (!holder.last_name.trim()) _set(errors, 'ticketHolders[' + index + '].last_name', 'Required')

    const addons = _get(holder, 'add_ons')
    _map(addons, (addon, aindex) => {
      if (!addon.id) _set(errors, 'ticketHolders[' + index + '].add_ons[' + aindex + '].id', 'Required')
      if (!addon.quantity)
        _set(errors, 'ticketHolders[' + index + '].add_ons[' + aindex + '].quantity', 'Required')
      else if (addon.quantity < 1)
        _set(
          errors,
          'ticketHolders[' + index + '].add_ons[' + aindex + '].quantity',
          'Quantity must be greater than 0',
        )
    })
  })
  return errors
}

export const validateGuestTicketsCRM = (data, props) => {
  const errors = {}

  if (props.event.flagAllowGuestTicketsByOptIns && data.quantityTopCustomers === 'all') {
    if (!data.defaultTicketTypeName) {
      _set(errors, 'defaultTicketTypeName', 'Required')
    } else if (!validateTicketTypeName(data.defaultTicketTypeName, props.tickets.concat(props.tables))) {
      _set(errors, 'defaultTicketTypeName', 'Invalid')
    }
    if (!data.defaultTicketQuantity) {
      _set(errors, 'defaultTicketQuantity', 'Required')
    } else if (isNaN(data.defaultTicketQuantity) || data.quantity < 0) {
      _set(errors, 'defaultTicketQuantity', 'Invalid')
    } else if (data.defaultTicketQuantity > 50) {
      _set(errors, 'defaultTicketQuantity', '>50')
    }
    return errors
  }

  const recipients = _get(data, 'recipients')

  recipients.forEach((r, index) => {
    if (!r.firstName) {
      _set(errors, 'recipients[' + index + '].firstName', 'Required')
    }
    if (!r.lastName) {
      _set(errors, 'recipients[' + index + '].lastName', 'Required')
    }
    if (!r.email) {
      _set(errors, 'recipients[' + index + '].email', 'Required')
    }
    if (r.email && !validateEmail(r.email)) {
      _set(errors, 'recipients[' + index + '].email', 'Invalid')
    }
    if (!r.ticketTypeName) {
      _set(errors, 'recipients[' + index + '].ticketTypeName', 'Required')
    } else if (!validateTicketTypeName(r.ticketTypeName, props.tickets.concat(props.tables))) {
      _set(errors, 'recipients[' + index + '].ticketTypeName', 'Invalid')
    }
    if (!r.quantity) {
      _set(errors, 'recipients[' + index + '].quantity', 'Required')
    } else if (isNaN(r.quantity) || r.quantity < 0) {
      _set(errors, 'recipients[' + index + '].quantity', 'Invalid')
    } else if (r.quantity > 50) {
      _set(errors, 'recipients[' + index + '].quantity', '>50')
    }
  })

  return errors
}
